var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"image-element",attrs:{"src":_vm.imageUrl},on:{"load":_vm.onImageLoaded,"click":_vm.handlePreview}}),_vm._v(" "),(_vm.showProgressBar)?_c('van-progress',{staticStyle:{"margin":"10px 0 0 0"},attrs:{"percentage":_vm.percentage}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-3526b3d1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/im/message-elements/image-element.vue
// module id = null
// module chunks = 